module.exports = __webpack_public_path__ + "img/week.b2f08a63.svg";